import { Box, Button, Container, Paper, styled, Typography } from '@mui/material';
import { FC, useCallback, useContext, useMemo } from 'react';
import { ClientConfigurationContext, ActiveDirectoryForgotPasswordForm } from '@ngt/openiddict';
import { useLocation } from 'react-router-dom';
import { parse } from 'qs';
import useNavigate from '@/hooks/router/useNavigate';
import useQueryString from '@/hooks/router/useQueryString';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const qsValues = [
    {
        key: 'redirectUrl' as 'redirectUrl',
        names: [
            'redirecturl',
            'returnurl',
            'returnuri'
        ]
    },
    {
        key: 'email' as 'email',
        names: [
            'email'
        ]
    }
]

const ForgotPassword: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const currentLocation = useMemo(() => `${location.pathname}${location.search}${location.hash}`, [location]);

    const {redirectUrl, email} = useQueryString(qsValues);

    const onAction = useCallback(async (url: string) => {
        navigate(url);
    }, [navigate]);

    return (
        <Container maxWidth="md">
            <Typography variant="h1" gutterBottom>
                Forgot Password?
            </Typography>
            <StyledPaper>
                <ActiveDirectoryForgotPasswordForm
                    currentUrl={currentLocation}
                    redirectUrl={redirectUrl}
                    email={email}
                    debug={import.meta.env.DEV}
                    onCancel={onAction}
                    onComplete={onAction}
                />
            </StyledPaper>
        </Container>
    );
}

export default ForgotPassword;